import BotResponseTreeNode from './BotResponseTreeNode';
import SlotValueType from './SlotValueType';

class LlmTreeNode {
  prompt: string;

  outputVariableName: string;

  aiModel: string;

  temperature: number;

  nextStep: BotResponseTreeNode | null;

  errorMessage: string;

  outputValueType: SlotValueType;

  constructor(
    prompt: string,
    outputVariableName: string,
    aiModel: string,
    temperature: number,
    nextStep: BotResponseTreeNode | null,
    errorMessage: string,
    outputValueType: SlotValueType = SlotValueType.FREE_TEXT
  ) {
    this.prompt = prompt;
    this.outputVariableName = outputVariableName;
    this.aiModel = aiModel;
    this.temperature = temperature;
    this.nextStep = nextStep;
    this.errorMessage = errorMessage;
    this.outputValueType = outputValueType;
  }
}

export default LlmTreeNode;
